module.exports = __webpack_public_path__ + "img/lowest-price-on-market.cd05cebb.png";